// extracted by mini-css-extract-plugin
module.exports = {"container":"ImportFail_container__1xfGt","img":"ImportFail_img__nWxrD","tip":"ImportFail_tip__11sWD"};